import { Component, computed, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LogoService } from '@ibc-shared/services/logo/logo.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  private logoService = inject(LogoService);

  logo = computed(() => {
    return this.logoService.logo();
  });
}
